<div class="kpiName">
   {{ kpiName }}
   <!--<span>
      <img
         *ngIf="kpiName == 'NP/DD'"
         src="assets/gtk/kpi_paw.png" />
      <img
         *ngIf="kpiName == 'SV/DD'"
         src="assets/gtk/kpi_sick.png" />
      <img
         *ngIf="kpiName == 'WH/Pet'"
         src="assets/gtk/kpi_hospital.png" />
      <img
         *ngIf="kpiName == '$/Invoice'"
         src="assets/gtk/kpi_invoice.png" />
      <img
         *ngIf="kpiName == 'KPI #5'"
         src="assets/gtk/kpi_doc.png" />
   </span>-->
</div>

<h3>{{ currentValue }}</h3>
<div
   *ngIf="vetcorAvg"
   class="vetcorAvg">
   Vetcor Avg. {{ vetcorAvg }}
</div>
<div
   *ngIf="showChart"
   class="kpi-apex-chart">
   <apx-chart
      [series]="[{ data: [vetcorAvg, currentValue] }]"
      [chart]="{ type: 'area', height: 110, sparkline: { enabled: true } }"
      [class]="currentValue >= vetcorAvg ? 'positive' : 'negative'"
      [fill]="{
         type: 'gradient',
         gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.8,
            opacityTo: 0,
            colorStops: [
               { offset: 0, opacity: 0.8 },
               { offset: 60, opacity: 0.15 },
               { offset: 70, opacity: 0.1 },
               { offset: 85, opacity: 0.08 },
               { offset: 100, opacity: 0 }
            ]
         }
      }"
      [stroke]="{
         curve: 'smooth',
         width: 3
      }"
      [dataLabels]="{ enabled: false }"
      [xaxis]="{
         labels: { show: false },
         axisBorder: { show: false },
         axisTicks: { show: false }
      }"
      [yaxis]="{ min: Math.min(currentValue, vetcorAvg) * 0.75, max: Math.max(currentValue, vetcorAvg) * 1.1, show: false }"
      [grid]="{ show: false }"
      [tooltip]="{ enabled: false }"
      [markers]="{ size: 0 }"></apx-chart>
</div>

<div
   *ngIf="vetcorAvg && currentValue"
   [ngClass]="currentValue >= vetcorAvg ? 'positiveGrowth' : 'negativeGrowth'">
   <i
      class="fas fa-arrow-up"
      *ngIf="currentValue >= vetcorAvg"></i>
   <i
      class="fas fa-arrow-down"
      *ngIf="currentValue < vetcorAvg"></i>
   {{ getPercentageChange(vetcorAvg, currentValue) }}
</div>
